import { render, staticRenderFns } from "./PersonnelLeaveDetail.vue?vue&type=template&id=65349f9e&scoped=true"
import script from "./PersonnelLeaveDetail.vue?vue&type=script&lang=js"
export * from "./PersonnelLeaveDetail.vue?vue&type=script&lang=js"
import style0 from "./PersonnelLeaveDetail.vue?vue&type=style&index=0&id=65349f9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65349f9e",
  null
  
)

export default component.exports